import React, { FC } from 'react';

import classNames from '../../helpers/classNames';
import { formatDateMedium } from '../../helpers/datetime';
import useTranslate from '../../hooks/useTranslate';
import { InspirationType } from '../../services/apis/inspirations/types';
import styles from './Inspiration.module.scss';

interface InspirationProps {
  inspiration: InspirationType;
}

const Inspiration: FC<InspirationProps> = props => {
  const { inspiration } = props;
  const { activeLanguage } = useTranslate();

  return (
    <div className={styles.container}>
      <img
        src={inspiration.imageUrl ?? ''}
        alt={inspiration.title}
        className={classNames(styles.image, 'mb-4')}
      />
      <div className={styles.content}>
        <p className={classNames(styles.date, 'mb-4')}>
          {formatDateMedium(inspiration.releaseDate, activeLanguage.code)}
          &emsp;&emsp;
          {inspiration.readTime > 0 && `${inspiration.readTime} min read`}
        </p>
        <h1 className="mb-4">{inspiration.title}</h1>
        <div dangerouslySetInnerHTML={{ __html: inspiration.preamble }} className="fw-bold" />
        <div dangerouslySetInnerHTML={{ __html: inspiration.content }} />
      </div>
    </div>
  );
};

export default Inspiration;
